import React, { useState, useEffect } from 'react';
import { Link , withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import validate from 'validate.js';
import theme from 'theme';
// import {
//     Grid,
//     // Button,
//     // IconButton,
//     // TextField,
//     // Link,
//     Typography
// } from '@material-ui/core';
// import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import { connect } from "react-redux";
import * as actions from "redux/actions/sessionActions";//
//import logo from '../../assets/logo2.png';
import { Facebook as FacebookIcon, Google as GoogleIcon } from 'icons';
import alertify from 'alertifyjs';
import 'alertifyjs/build/css/alertify.css';
import { Translate, I18n } from "react-redux-i18n";
import 'assets/css/signin.css';


const schema = {
    email: {
        presence: { allowEmpty: false, message: 'is required' },
        email: true,
        length: {
            maximum: 64
        }
    },
};

// const useStyles = {
//     root: {
//         backgroundColor: theme.palette.background.default,
//         height: '100%'
//     },
//     grid: {
//         height: '100%'
//     },
//     quoteContainer: {
//         [theme.breakpoints.down('md')]: {
//             display: 'none'
//         }
//     },
//     quote: {
//         backgroundColor: theme.palette.neutral,
//         height: '100%',
//         display: 'flex',
//         justifyContent: 'center',
//         alignItems: 'center',
//         backgroundSize: 'cover',
//         backgroundRepeat: 'no-repeat',
//         backgroundPosition: 'center'
//     },
//     quoteInner: {
//         textAlign: 'center',
//         flexBasis: '600px'
//     },
//     quoteText: {
//         color: theme.palette.black,
//         fontWeight: 300
//     },
//     name: {
//         marginTop: theme.spacing.spacing3,
//         color: theme.palette.black
//     },
//     bio: {
//         color: theme.palette.black
//     },
//     contentContainer: {},
//     content: {
//         height: '100%',
//         display: 'flex',
//         flexDirection: 'column'
//     },
//     contentHeader: {
//         display: 'flex',
//         alignItems: 'center',
//         paddingTop: theme.spacing.spacing5,
//         paddingBototm: theme.spacing.spacing2,
//         paddingLeft: theme.spacing.spacing2,
//         paddingRight: theme.spacing.spacing2
//     },
//     logoImage: {
//         marginLeft: theme.spacing.spacing4
//     },
//     contentBody: {
//         flexGrow: 1,
//         display: 'flex',
//         alignItems: 'center',
//         justifyContent: 'center',
//     },
//     form: {
//         paddingLeft: 100,
//         paddingRight: 100,
//         paddingBottom: 125,
//         flexBasis: 700,
//         [theme.breakpoints.down('sm')]: {
//             paddingLeft: theme.spacing.spacing2,
//             paddingRight: theme.spacing.spacing2
//         }
//     },
//     title: {
//         marginTop: theme.spacing.spacing3
//     },
//     socialButtons: {
//         marginTop: theme.spacing.spacing3
//     },
//     socialIcon: {
//         marginRight: theme.spacing.spacing1
//     },
//     sugestion: {
//         marginTop: theme.spacing.spacing2
//     },
//     textField: {
//         marginTop: theme.spacing.spacing2
//     },
//     signInButton: {
//         margin: theme.spacing.spacing2 + ' 0px'
//     }
// };

const Recovery = props => {
    const { history } = props;


    const [formState, setFormState] = useState({
        isValid: false,
        values: {},
        touched: {},
        errors: {}
    });

    useEffect(() => {
        props.error && alertify.error(props.error);
        if (props.success) {
            alertify.success(props.success);
            history.push('/login');
        }
        props.Logout();
        const errors = validate(formState.values, schema);

        setFormState(formState => ({
            ...formState,
            isValid: errors ? false : true,
            errors: errors || {}
        }));
    }, [formState.values]);

    const handleBack = () => {
        history.goBack();
    };

    const handleChange = event => {
        event.persist();

        setFormState(formState => ({
            ...formState,
            values: {
                ...formState.values,
                [event.target.name]:
                    event.target.type === 'checkbox'
                        ? event.target.checked
                        : event.target.value
            },
            touched: {
                ...formState.touched,
                [event.target.name]: true
            }
        }));
    };

    const handleRecovery = async event => {
        event.preventDefault();
        await props.Recovery(formState.values.email);
        setFormState(formState => ({
            ...formState,
            isValid: false,
            values: {},
            touched: {},
            errors: {},
        }));
    };

    const hasError = field =>
        formState.touched[field] && formState.errors[field] ? true : false;

    return (
            <container className='' style={{display:'flex', justifyContent:'center', alignItems:'center', height:'100vh', width:'100vw'}}>
               <div className='signin-card'>
                    <div className='sign-in-content'>
                        <div className='signin-header'>
                            <h2 className='signin-title'>
                                <Translate value="recovery_password" />
                            </h2>
                            {/* <span className="signin-subtitle">
                                <Translate value="recovery_email" />
                            </span> */}
                        </div>
                        <form  className='signin-form'
                            onSubmit={handleRecovery}
                        >   
                            <input
                                className='input'
                                error={hasError('email')}
                                helperText={
                                    hasError('email') ? formState.errors.email[0] : null
                                }
                                fullWidth
                                placeHolder={"Email"}
                                name="email"
                                onChange={handleChange}
                                type="email"
                                value={formState.values.email || ''}
                                // variant="outlined"
                            />

                            <button
                                className='btn btn-primary btn-block '
                                color="primary"
                                disabled={!formState.isValid}
                                fullWidth
                                size="large"
                                type="submit"
                                variant="contained"
                            >
                                <Translate value="recovery_now" />
                            </button>
                          <p className='signin-sugestion mt-3'>
                             <span className='text-muted f-14'>
                                <Translate value="don_have_account" /> {'  '}
                            </span>
                                <Link
                                   className='linked-primary'
                                    to="/signup"

                                >
                                    <Translate value="sign_up" />
                                </Link>
                                
                                {' '} <Translate value="or" />  {' '}
                                <Link
                                  className='linked-primary'
                                    to="/login"
                                >
                                    <Translate value="sign_in" />
                                </Link>
                            </p>
                        </form>
                    </div>
               </div>
        </container>
    );
};

Recovery.propTypes = {
    history: PropTypes.object
};

function mapStateToProps(reducer) {
    //console.log(reducer);
    return {
        error: reducer.session.error,
        success: reducer.session.success,
    };
}

const mapDispatchToProps = dispatch => ({
    Recovery: (email) =>
        dispatch(actions.recovery({ email })),
    Logout: () =>
        dispatch(actions.logout()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Recovery);